import React from "react"
import Button from "aldoo-ra/Button"
import useT from "../hooks/useT"
import { sanitizeText } from "../utils/pageMeta"
import { authorUrl } from "../utils/contentRoutes"

/** An author's bio (HTML from the catalog) as plain paragraphs: one per <p> / <br> block. */
const paragraphs = (html) =>
  String(html || "")
    .split(/<\/?p\b[^>]*>|<br\s*\/?>|\r?\n\s*\r?\n/i)
    .map((part) => sanitizeText(part, 5000))
    .filter(Boolean)

/**
 * The product's authors with a bio, under its description: who wrote it, in
 * text the page renders on the server (a crawler reads it), with a link to the
 * author's page. Centered in a reading column, as the page's other sections
 * are; the author's other books are a row of their own (MoreByAuthor).
 */
export default function AboutAuthor({ product }) {
  const t = useT()
  const authors = (product?.author || []).filter((a) => a?.name && paragraphs(a.description).length)
  if (!authors.length) return null
  return (
    <section className="w-full flex flex-col items-center mb-[60px]" data-testid="about-author">
      <h3 className="m-0 mb-8 text-[24px] md:text-[28px] font-bold text-center">{t`About the author`}</h3>
      {authors.map((author) => (
        <div key={author._id || author.slug || author.name} className="w-full max-w-[760px] flex flex-col items-center mb-6 last:mb-0">
          <Button variant="link_accent" href={authorUrl(author)} className="text-[18px] text-center">
            {author.name}
          </Button>
          {paragraphs(author.description).map((text, i) => (
            <p key={i} className="m-0 mt-3 w-full text-[15px] md:text-[16px] leading-relaxed text-left text-text_secondary">
              {text}
            </p>
          ))}
          {/* a bio from Wikipedia credits its article, as its licence asks */}
          {author.bioSource?.name === "Wikipedia" && author.bioSource.url && (
            <p className="m-0 mt-2 w-full text-[13px] text-text_secondary">
              {t`Source`}:{" "}
              <a href={author.bioSource.url} target="_blank" rel="noopener noreferrer" className="underline hover:text-primary">
                {t`Wikipedia`}
              </a>{" "}
              ({author.bioSource.license || "CC BY-SA 4.0"})
            </p>
          )}
        </div>
      ))}
    </section>
  )
}
